export const LayoutHome = () => import("../components/LayoutHome.vue");
export const ActivityHome = () => import("../components/ActivityHome.vue");
export const page404 = () => import("../pages/404.vue");
